import { ApiResponse, getRequest } from "@/data/apiClient";

export const getClientConfigValue = async (
  name: string
): Promise<ApiResponse<{ value: any }>> =>
  getRequest("client/config", { name });
